import { render } from "./AdminLogin.vue?vue&type=template&id=89bc366c&scoped=true"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"

import "./AdminLogin.vue?vue&type=style&index=0&id=89bc366c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bc366c"]])

export default __exports__